import { IMemberPosition } from '@/core/interfaces/member-position.interface';
import { ED_CONTEXT_MENU_TYPES } from '@/plugins/ed-context-menu/ed-context-menu.values';
import { EdContextMenuModel } from '@/plugins/ed-context-menu/models/ed-context-menu.model';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import EdMembersConnectedList from '../ed-members-connected-list/ed-members-connected-list.component.vue';

@Component({})
export default class EdMembersConnectedComponent extends Vue {

  @Prop() readonly membersConnected: IMemberPosition[];
  @Prop() readonly prefix: string;

  public maxMembers: number = 3;
  
  get prefixKey() {
    return this.prefix ? this.prefix : 'M';
  }

  get membersConnectedFiltered() {
    let members = [...this.membersConnected];
    return members.splice(0, this.maxMembers);
  }

  seeMore() {
    let position = this.$el.getBoundingClientRect();
    let x = position.x - 36 > 160 ? position.x - 36 : 100;
    this.$EdContextMenu.createBlank({
      position: { x, y: position.y },
      comp: EdMembersConnectedList,
      type: ED_CONTEXT_MENU_TYPES.BLANK,
      params: {
        members: this.membersConnected,
        prefix: this.prefix
      },
      className: 'ed-context-menu__members-connected'
    });
  }
  
}